import { PlatformApiClient } from "./api";
import type { OrganizationContext } from "./types";
import { Page, PageHeader, ProductSubnav } from "./adaptive/primitives";
import { MenuCatalogView } from "./menu/MenuCatalogView";
import { MenuAgentView } from "./menu/MenuAgentView";
import { MenuSettingsView } from "./menu/MenuSettingsView";

type MenuView = "catalog" | "agent" | "settings";

export function menuViewForPath(pathname: string): MenuView {
  const match = pathname.match(/^\/o\/[^/]+\/menu(?:\/([^/]+))?(?:\/.*)?$/);
  const section = match?.[1] ?? "";
  if (section === "agent") return "agent";
  if (section === "settings") return "settings";
  return "catalog";
}

export function MenuProduct({ organization, api, onExpired }: { organization: OrganizationContext; api: PlatformApiClient; onExpired: () => void }) {
  const slug = organization.organization.slug;
  const view = menuViewForPath(window.location.pathname);
  const base = `/o/${slug}/menu`;
  function navigate(path: string) { window.history.pushState(null, "", path); window.dispatchEvent(new PopStateEvent("popstate")); }
  const nav = [
    { key: "catalog", label: "Carta", href: base, icon: <span className="menu-nav-icon catalog" aria-hidden="true" /> },
    { key: "agent", label: "Agente", href: `${base}/agent`, icon: <span className="menu-nav-icon agent" aria-hidden="true" /> },
    { key: "settings", label: "Configuración", href: `${base}/settings`, icon: <span className="menu-nav-icon settings" aria-hidden="true" /> },
  ] as const;
  return (
    <Page className="menu-product" density="compact">
      <PageHeader
        className="menu-product-header"
        eyebrow="ClickDialog Menu"
        title="Menú Digital"
        description="Administrá tu carta, el agente y los accesos públicos desde el mismo espacio."
      />
      <ProductSubnav
        className="menu-product-nav"
        items={nav}
        activeKey={view}
        ariaLabel="Navegación de Menu"
        onNavigate={navigate}
      />
      <div className="menu-product-body">
        {view === "catalog" ? <MenuCatalogView slug={slug} api={api} onExpired={onExpired} /> : view === "agent" ? <MenuAgentView slug={slug} api={api} onExpired={onExpired} /> : <MenuSettingsView slug={slug} api={api} onExpired={onExpired} />}
      </div>
    </Page>
  );
}
